import { render } from "./SidenavList.vue?vue&type=template&id=6e16ba3a&scoped=true&ts=true"
import script from "./SidenavList.vue?vue&type=script&lang=ts"
export * from "./SidenavList.vue?vue&type=script&lang=ts"

import "./SidenavList.vue?vue&type=style&index=0&id=6e16ba3a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e16ba3a"]])

export default __exports__